import { onBeforeUnmount, onMounted } from '@vue/composition-api'
import useAppConfig from '@core/@app-config/useAppConfig'

export default function useToggleThemeShortcut() {
  const { isDark } = useAppConfig()

  const handleKeyDown = event => {
    if (event.altKey && event.key === 't') {
      isDark.value = !isDark.value
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })
}
